const search = document.querySelector('#site-search');
const nav = document.querySelector('#navbar-main');

search.addEventListener('focus', e => {
	nav.classList.add('fade');
}, true);

search.addEventListener('blur', e => {
	nav.classList.remove('fade');
}, true);